import { CrudPage } from '@restavo/crud';
import React from 'react';
import { useMainMenuSettingsPage } from 'src/features/mainMenuSettings';

const MainMenuSettings = React.memo(() => {
  const { page } = useMainMenuSettingsPage();
  return <CrudPage {...page} />;
});

export default MainMenuSettings;
